import { DATA_TRANSFER_FIELDS } from './dataTransfer';
import { TRANSFERRING_BANK_TO_DO } from './transferringBankToDo';

export const FORM_FIELDS = [DATA_TRANSFER_FIELDS, TRANSFERRING_BANK_TO_DO];
